<template>
  <v-card
    height="100%"
    dark
    flat
    class="d-flex justify-center align-center transparent py-10"
  >
    <v-card width="1100px" v-if="$vuetify.breakpoint.lgAndUp">
      <v-row align="center" no-gutters>
        <v-col cols="5" class="d-flex align-center">
          <v-card flat>
            <v-container class="pa-12">
              <v-card-title>
                <vue-typed-js
                  :strings="['Projects I\'ve worked on.']"
                  :typeSpeed="40"
                >
                  <span class="typing"></span>
                </vue-typed-js>
              </v-card-title>
              <v-card-text class="text-justify">
                Here are some projects that I have worked on. More are being
                worked on as the days progress.
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="7">
          <v-sheet>
            <v-carousel height="400" hide-delimiters show-arrows-on-hover>
              <v-carousel-item v-for="(project, i) in projects" :key="i">
                <v-card height="100%" :href="project.url">
                  <v-img
                    :src="project.img"
                    class="white--text align-end"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="100%"
                  >
                    <v-container>
                      <v-card class="grey darken-1">
                        <v-card-title v-text="project.title"></v-card-title>
                        <v-card-text
                          class="text--white"
                          v-text="project.bio"
                        ></v-card-text>
                      </v-card>
                    </v-container>
                  </v-img>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>
    <v-card v-if="$vuetify.breakpoint.md" max-width="600px">
      <v-card-title>
        <vue-typed-js :strings="['Projects I\'ve worked on.']" :typeSpeed="40">
          <span class="typing"></span>
        </vue-typed-js>
      </v-card-title>
      <v-card-text class="text-justify">
        Here are some projects that I have worked on. More are being worked on
        as the days progress.
      </v-card-text>
      <v-carousel height="344" hide-delimiters show-arrows-on-hover>
        <v-carousel-item v-for="(project, i) in projects" :key="i">
          <v-card height="100%" :href="project.url">
            <v-img
              :src="project.img"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="100%"
            >
              <v-container>
                <v-card class="grey darken-1">
                  <v-card-title v-text="project.title"></v-card-title>
                  <v-card-text
                    class="text--white"
                    v-text="project.bio"
                  ></v-card-text>
                </v-card>
              </v-container>
            </v-img>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-card>
    <v-card
      v-if="$vuetify.breakpoint.smAndDown"
      :max-width="$vuetify.breakpoint.sm ? '564' : '344'"
    >
      <v-card-title>
        <vue-typed-js :strings="['Projects I\'ve worked on.']" :typeSpeed="40">
          <span class="typing"></span>
        </vue-typed-js>
      </v-card-title>
      <v-card-text class="text-justify">
        Here are some projects that I have worked on. More are being worked on
        as the days progress.
      </v-card-text>
      <v-carousel height="344" hide-delimiters show-arrows-on-hover>
        <v-carousel-item v-for="(project, i) in projects" :key="i">
          <v-card height="100%" :href="project.url">
            <v-img
              :src="project.img"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="100%"
            >
              <v-container>
                <v-card class="grey darken-1">
                  <v-card-title v-text="project.title"></v-card-title>
                </v-card>
              </v-container>
            </v-img>
          </v-card>
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    projects: [
      {
        title: "Checkup+ : Hospital Management System",
        bio:
          "A personal project on making a management system for a hospital. This project uses Vue.js, Vuetify, Vuex, VueRouter, Axios for the frontend and Node.js, Express.js and Mongoose for the backend. I use mongodb as a database.",
        img: "https://i.imgur.com/4KzlVf9.png",
        url: "https://github.com/lychunvira18/checkup_clinic_management_system/"
      },
      {
        title: "Classtime : Class Streaming Service",
        bio:
          "Part of developing the front end of the class streaming service for the school. This project was designed using AdobeXD and developed using Vue.js, Vuetify, Vuex and VueRouter.",
        img: "https://i.imgur.com/wYdvGtd.png",
        url: ""
      },
      {
        title: "Coursework : Learning Community",
        bio:
          "A community for students to stream courses and discuss in related communities. I'm in charge to design the prototype, develop and lead a team to develop this product. Prototyped with AdobeXD and developed with Vue.",
        img: "https://i.imgur.com/sZX5mPJ.png",
        url: ""
      }
    ]
  })
};
</script>

<style></style>
